export default __webpack_public_path__ + "static/media/thirdArti.99048095.png";